<template>
    <div class="w-100" style="height: calc(100% - 40px);">
        <p-inspection-contact-card
            v-for     = "(contact, index) in contacts"
            :key      = "index"
            :contact  = "contact"
            class     = "mb-4"
            @favorite = "onFavorite"
        />
    </div>
</template>

<script>
import PInspectionContactCard
    from "@/modules/dis/components/inspection/contacts/components/private/PInspectionContactCard.vue";

export default {
    name: "PInspectionContactIterator",
    components: {
        PInspectionContactCard
    },

    props: {
        contacts: {

        }
    },

    methods: {
        onFavorite (contact) {
            this.$emit("favorite", contact)
        }
    }
}
</script>

<style scoped>

</style>